import {Observable} from 'rxjs';


export interface INotification {
  token: string;
}


export const NOTIFICATIONS_REPOSITORY = 'NotificationsRepository';

export interface NotificationsRepository {
  notification$: Observable<INotification>;

  renewToken(token: string): Promise<void>;
}
